export default async ({ data }) => {
  const { fb } = data;
  if (fb) {
    (function fb(d, s, id) {
      const { locale } = data;
      const { origin } = window.location;

      const fbLikeButton = document.querySelector('.fb-like');
      if (!fbLikeButton) {
        return;
      }
      fbLikeButton.setAttribute('data-href', origin);

      let newLocale = 'en_US';
      if (locale === 'ar-AE') {
        newLocale = 'ar_AR';
      } else {
        newLocale = locale.replace('-', '_');
      }

      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      const js = d.createElement(s);
      js.id = id;
      js.src = `https://connect.facebook.net/${newLocale}/sdk.js#xfbml=1&version=v3.0`;
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }
};
